import { CapabilitiesState } from "../reducers/capabilitiesReducer";
import { CapabilitiesScope } from "../scopes";
import { createOnboardingAsyncAction } from "./helpers";

export enum CapabilitiesActions {
  UPDATE_CAPABILITIES_START = "@capabilities/UPDATE_CAPABILITIES_START",
  UPDATE_CAPABILITIES_COMPLETED = "@capabilities/UPDATE_CAPABILITIES_COMPLETED",
  UPDATE_CAPABILITIES_ERROR = "@capabilities/UPDATE_CAPABILITIES_ERROR",
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const capabilitiesActions: any = {
  updateCapabilities: createOnboardingAsyncAction(
    CapabilitiesScope,
    CapabilitiesActions.UPDATE_CAPABILITIES_START,
    () => ({}),
    CapabilitiesActions.UPDATE_CAPABILITIES_COMPLETED,
    (capabilitiesState: CapabilitiesState) => ({
      capabilitiesState,
    }),
    CapabilitiesActions.UPDATE_CAPABILITIES_ERROR,
    (error: Error) => ({ error })
  ),
};
